import { render, staticRenderFns } from "./noticeItem.vue?vue&type=template&id=0ed0979a&"
import script from "./noticeItem.vue?vue&type=script&lang=js&"
export * from "./noticeItem.vue?vue&type=script&lang=js&"
import style0 from "./noticeItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports